import { render, staticRenderFns } from "./rma.vue?vue&type=template&id=2c0c6264&"
import script from "./rma.vue?vue&type=script&lang=js&"
export * from "./rma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports